import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHardeMuziek = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M30 6H10v28h20z"
    />
    <path
      fill="#B3E9B1"
      d="M20 32a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M20 20a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-6 5a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M20 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M20 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M27.84 6h-.5v10.29h1V8.74c.186.216.406.418.668.594.574.386 1.316.626 2.262.626v-1c-.769 0-1.313-.192-1.704-.456a2.53 2.53 0 0 1-.85-.996 3.8 3.8 0 0 1-.375-1.486V6z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M26.12 15.08a1.21 1.21 0 1 0 0 2.42 1.21 1.21 0 0 0 0-2.42m-2.21 1.21a2.21 2.21 0 1 1 4.42 0 2.21 2.21 0 0 1-4.42 0M32.1 12h-.5v8.29h1v-5.518c.191.225.42.437.693.621.582.392 1.336.637 2.297.637v-1c-.784 0-1.339-.197-1.738-.466a2.6 2.6 0 0 1-.867-1.02 3.9 3.9 0 0 1-.337-1.074 4 4 0 0 1-.047-.447l-.001-.02v-.004z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M30.35 19.04a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-2.25 1.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHardeMuziek);

export default ForwardRef;
